import {
  STORAGE_OPTIONS,
  StorageService,
  useStorageState,
} from '@/common/integrations/storage/storage.service';
import { IEmployeeBudget } from './budgets.types';

function updateActiveBudgetsCount(budgets: IEmployeeBudget[]) {
  StorageService.setStorageItem(
    STORAGE_OPTIONS.ACTIVE_BUDGETS_COUNT,
    budgets.filter((budget) => budget.status === 'active').length
  );
}

export function useBudgetsStorage() {
  const { value, isLoading } = useStorageState(
    STORAGE_OPTIONS.ACTIVE_BUDGETS_COUNT
  );

  const activeBudgetsCount = isNaN(Number(value)) ? 0 : Number(value);

  return {
    storage: {
      activeBudgetsCount,
    },
    isLoading,
  };
}

export const BudgetsStorage = {
  updateActiveBudgetsCount,
};
